import React from 'react';
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Real ART-WER project photos (from the offerte)
import projectImg1 from '../../assets/images/artwer/project-1-balkon-hilversum-card.jpg';
import projectImg2 from '../../assets/images/artwer/project-2-antislip-apeldoorn-card.jpg';
import projectImg3 from '../../assets/images/artwer/project-3-galerij-amsterdam-card.jpg';
import projectImg4 from '../../assets/images/artwer/project-4-hemelwater-bussum-card.jpg';
import projectImg5 from '../../assets/images/artwer/project-5-buitentrap-nijverdal-card.jpg';
import projectImg6 from '../../assets/images/artwer/project-6-vloercoating-amsterdam-card.jpg';
import projectImg1Webp from '../../assets/images/artwer/project-1-balkon-hilversum-card.webp';
import projectImg2Webp from '../../assets/images/artwer/project-2-antislip-apeldoorn-card.webp';
import projectImg3Webp from '../../assets/images/artwer/project-3-galerij-amsterdam-card.webp';
import projectImg4Webp from '../../assets/images/artwer/project-4-hemelwater-bussum-card.webp';
import projectImg5Webp from '../../assets/images/artwer/project-5-buitentrap-nijverdal-card.webp';
import projectImg6Webp from '../../assets/images/artwer/project-6-vloercoating-amsterdam-card.webp';

export const projectImages = [
  { image: projectImg1, webp: projectImg1Webp, alt: 'Balkonrenovatie met Soprema ALSAN PMMA in Hilversum' },
  { image: projectImg2, webp: projectImg2Webp, alt: 'Antislip eindlaag in een garage in Apeldoorn' },
  { image: projectImg3, webp: projectImg3Webp, alt: 'Opgeleverde galerijvloer in Amsterdam' },
  { image: projectImg4, webp: projectImg4Webp, alt: 'Herstelde hemelwaterafvoer in Bussum' },
  { image: projectImg5, webp: projectImg5Webp, alt: 'Antislip op een buitentrap in Nijverdal' },
  { image: projectImg6, webp: projectImg6Webp, alt: 'Vloercoating in een technische ruimte in Amsterdam' },
];

const ProjectTwo = () => {
  // WCAG 2.2.2: no auto-advancing content for people who ask the OS for less motion.
  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const swiperOptions = {
    modules: [A11y, Autoplay, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 30,
    speed: prefersReducedMotion ? 0 : 2000,
    autoplay: prefersReducedMotion
      ? false
      : { delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true },
    loop: true,
    // Real controls, scoped to this section (the template's .swiper-button-next1
    // selectors pointed at elements that never existed).
    navigation: {
      nextEl: '.project-two .swiper-button-next',
      prevEl: '.project-two .swiper-button-prev',
    },
    pagination: { el: '.project-two .swiper-pagination', type: 'bullets', clickable: true },
    a11y: {
      prevSlideMessage: 'Vorige projecten',
      nextSlideMessage: 'Volgende projecten',
      paginationBulletMessage: 'Ga naar projectfoto {{index}}',
    },
    breakpoints: {
      0: { spaceBetween: 0, slidesPerView: 1 },
      375: { spaceBetween: 30, slidesPerView: 1 },
      575: { spaceBetween: 30, slidesPerView: 1 },
      768: { spaceBetween: 30, slidesPerView: 2 },
      992: { spaceBetween: 30, slidesPerView: 3 },
      1200: { spaceBetween: 30, slidesPerView: 4 },
      1320: { spaceBetween: 30, slidesPerView: 4 },
    },
  };

  return (
    <>
      <section className="project-two" id="projecten">
        <h2 className="sr-only">Recente projecten</h2>
        <div className="container">
          <Swiper {...swiperOptions}>
            {projectImages.map((project, index) => (
              <SwiperSlide key={index}>
                <div className="project-two__single">
                  <div className="project-two__img">
                    <picture>
                      <source srcSet={project.webp} type="image/webp" />
                      <img src={project.image} alt={project.alt} width="1000" height="750" loading="lazy" />
                    </picture>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="project-two__nav">
            <button type="button" className="swiper-button-prev" aria-label="Vorige projecten"></button>
            <div className="swiper-pagination"></div>
            <button type="button" className="swiper-button-next" aria-label="Volgende projecten"></button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjectTwo;
